import { messages } from '../../i18n';
import { clearLegendWrapper } from './legend-wrapper.hoc';
import { useOpenVizChartSpec } from '../../common/redux/selectors/viz-selector.hook';
import { css } from '@emotion/react';
import { getFrontendUrl } from '../../common';
import { isDashletMode } from '../../auth';
import { buildUrl } from '../../../../../mfe/src/mfe.utils';
import { isEmpty } from 'lodash';
import { fieldInFilterValidationMessage } from './missing-field-placeholder/missing-field-placeholder.utils';

export const ChartPlaceHolder = ({ children, vizId, hasError = false }) => {
  const chartSpec = useOpenVizChartSpec({ discoveryId: vizId });
  const { placeholderImage = '' } = chartSpec ?? {};
  let imgSrc = placeholderImage;

  if (isDashletMode() && placeholderImage) {
    try {
      const frontendUrl = getFrontendUrl();
      const { pathname: path = '' } = new URL(placeholderImage);
      imgSrc = buildUrl({ baseUrl: frontendUrl, path });
    } catch (error) {
      console.error('Invalid placeholderImage URL:', placeholderImage, error);
      imgSrc = '';
    }
  }

  return (
    <div className={`viz-placeholder${hasError ? ' error' : ''}`}>
      <div
        css={css`
          display: flex;
          flex-direction: column;
        `}
      >
        {!isEmpty(imgSrc) && (
          <img
            css={css`
              max-height: 150px;
            `}
            className={'chart-placeholder-img'}
            src={imgSrc}
          />
        )}
        {children}
      </div>
    </div>
  );
};
export const EmptyFieldPlaceholder = ({ vizId, validation }) => {
  const chartSpec = useOpenVizChartSpec({ discoveryId: vizId });
  const { requiredFields } = chartSpec ?? {};
  const fieldInFilterValidationMsg = fieldInFilterValidationMessage({
    validation,
  });
  const placeHolderLabel = isDashletMode() ? (
    <p className={'dashlet-msg'}>{messages.baseChart.dashletEmptyFieldText}</p>
  ) : (
    <p>
      {messages.baseChart.emptyFieldTextStart}
      <strong>{messages.baseChart.fieldList}</strong>
      {messages.baseChart.emptyFieldTextEnd}
      {requiredFields && (
        <>
          <br />
          {messages.baseChart.emptyFieldHintText}
        </>
      )}
      {fieldInFilterValidationMsg && (
        <>
          <br />
          <br />
        </>
      )}
      {fieldInFilterValidationMsg}
    </p>
  );
  return <ChartPlaceHolder vizId={vizId}>{placeHolderLabel}</ChartPlaceHolder>;
};

export const LegendAwareChartPlaceholder: any = clearLegendWrapper(
  EmptyFieldPlaceholder,
);

export const ChartPlaceholderWithMessage: any =
  clearLegendWrapper(ChartPlaceHolder);
